import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["actionGroup", "retry", "position", "testId", "title", "icon", "hideIcon"];
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { SmartLinkAlignment, SmartLinkDirection } from '../../../../../../constants';
import { LinkIcon } from '../../../elements';
import Block from '../../block';
import ElementGroup from '../../element-group';
import TitleBlockErroredViewOld from './TitleBlockErroredViewOld';

/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */
var TitleBlockErroredViewNew = function TitleBlockErroredViewNew(_ref) {
  var actionGroup = _ref.actionGroup,
    retry = _ref.retry,
    position = _ref.position,
    testId = _ref.testId,
    title = _ref.title,
    icon = _ref.icon,
    hideIcon = _ref.hideIcon,
    blockProps = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = retry || {},
    descriptor = _ref2.descriptor,
    onClick = _ref2.onClick,
    values = _ref2.values;
  var hasAction = onClick !== undefined;
  return /*#__PURE__*/React.createElement(Block, _extends({}, blockProps, {
    testId: "".concat(testId, "-errored-view")
  }), !hideIcon && /*#__PURE__*/React.createElement(LinkIcon, {
    overrideIcon: icon,
    position: position
  }), title, descriptor && /*#__PURE__*/React.createElement(ElementGroup, {
    direction: SmartLinkDirection.Horizontal,
    align: SmartLinkAlignment.Right
  }, /*#__PURE__*/React.createElement(Box, {
    onClick: onClick,
    testId: "".concat(testId, "-errored-view-message"),
    tabIndex: hasAction ? 0 : -1
  }, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, descriptor, {
    values: values
  })))), actionGroup);
};
var TitleBlockErroredView = function TitleBlockErroredView(props) {
  if (fg('bandicoots-compiled-migration-smartcard')) {
    return /*#__PURE__*/React.createElement(TitleBlockErroredViewNew, props);
  } else {
    return /*#__PURE__*/React.createElement(TitleBlockErroredViewOld, props);
  }
};
export default TitleBlockErroredView;